import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Divider from '@material-ui/core/Divider'
import Collapse from '@material-ui/core/Collapse'
import ServiceLayersList from './ServiceLayersList'
import LocationSelector from './LocationSelector'
import ServiceDrawerCard from './ServiceDrawerCard'
import ServiceActions from '../redux/serviceRedux'
import ObjectActions from '../redux/objectRedux'
import UploadActions from '../redux/uploadRedux'
import LayersIcon from '@material-ui/icons/Layers'
import MultiSelectIcon from '@material-ui/icons/ControlPoint'
import ClearSelectionIcon from '@material-ui/icons/Clear'
import CloudIcon from '@material-ui/icons/Cloud'
import FileUploadIcon from '@material-ui/icons/FileUpload'
import Tooltip from './Tooltip'
import MopraMiniTable from '../tables/MopraMiniTable'
import MopraWellsitesLineChartContainer from '../charts/MopraWellsitesLineChartContainer'
import WellsiteRankContainer from '../charts/WellsiteRankContainer'
import WellsiteRankContainerSimple from '../charts/WellsiteRankContainerSimple'
import RiverIcePointLineChartContainer from '../charts/RiverIcePointLineChartContainer'
import RiverIceLineChartContainer from '../charts/RiverIceLineChartConatiner'
import WaterSedimentBarChart from '../charts/WaterSedimentBarChart'
import WaterTemperatureBarChart from '../charts/WaterTemperatureBarChart'
import WaterLakeTssBarChart from '../charts/WaterLakeTssBarChart'
import WaterLakeChlBarChart from '../charts/WaterLakeChlBarChart'
import InfrastructurePieChart from '../charts/InfrastructurePieChart'
import InfrastructureBufferChart from '../charts/InfrastructureBufferChart'
import IceBuoyChartContainer from '../charts/IceBuoyChartContainer'
import LandDeformationLineChart from '../charts/LandDeformationLineChart'
import LeakDetectionLineChart from '../charts/LeakDetectionLineChart'
import SmartIceQamutikPointChart from '../charts/SmartIceQamutikPointChart'
import DebugDrawer from '../debug/DebugDrawer'
import { DEBUG } from '../config/constants'
import MopraMoodChartContainer from '../charts/MopraMoodChartContainer'
import ServiceCardHeader from './ServiceCardHeader'
import { makeGetPermission } from '../selectors/permissionSelector'
import { makeGetServiceAuthorized } from '../selectors/serviceAuthorizationSelector'
// import Weather from './Weather'
import WeatherContainer from '../containers/WeatherContainer'
import ItemSummaryContainer from '../containers/ItemSummaryContainer'
import MopraSummaryContainer from '../containers/MopraSummaryContainer'
import withErrorHandler from '../errors/withErrorHandler'
import Streetview from '../containers/StreetviewContainer'
import AutocompleteContainer from '../containers/AutocompleteContainer'

const styles = {
  card: {
    margin: 20,
    backgroundColor: 'rgba(255, 255, 255, 1)',
    borderRadius: 5
  },
  flexGrow: {
    flex: '1 1 auto'
  },
  media: {
    height: 100
  },
  drawerPaper: {},
  content: {
    padding: '5px 0px 5px 0px',
    color: 'red'
  }
}

class ServiceCard extends PureComponent {
  handleClose = () => {
    const { serviceCardChanged } = this.props
    serviceCardChanged(null)
  }

  handleLayerConfigurationClicked = () => {
    const { actions } = this.props
    actions.layerConfigurationToggled()
  }

  handleMultiselectToggled = () => {
    const { actions } = this.props
    actions.multiselectToggled()
  }

  handleClearSelectionClicked = () => {
    const { actions } = this.props
    actions.objectsSelected(null)
  }

  handleWeatherToggled = () => {
    const { actions } = this.props
    actions.weatherToggled()
  }

  handleUploadToggled = () => {
    const { actions } = this.props

    actions.uploadToggled()
  }

  render () {
    const {
      classes,
      handleClose,
      handleLocationClicked,
      handleLayerToggled,
      layerConfigurationOpen,
      locationConfigurationOpen,
      weatherOpen,
      layersRendered,
      locationSelected,
      multiselectToggled,
      uploadToggled,
      service,
      services,
      serviceCardChanged
    } = this.props

    return (
        <ServiceDrawerCard>

        <ServiceCardHeader
          service={service}
          services={services}
          serviceCardChanged={serviceCardChanged}
          handleClose={handleClose}
          />

        <CardActions >
          <LocationSelector service={service} onMenuItemClick={handleLocationClicked} defaultValue={locationSelected} />
          {DEBUG && <DebugDrawer />}
          {service.upload && (
            <Tooltip id={'uploadIcon'} title={'upload file'}>
              <IconButton
                onClick={this.handleUploadToggled}
                color={uploadToggled ? 'inherit' : 'default'}
                >
                <FileUploadIcon />
              </IconButton>
            </Tooltip>
          )}
          {service.weather &&
          <Tooltip id={'weatherIcon'} title={'current weather'}>
            <IconButton
              onClick={this.handleWeatherToggled}
              color={weatherOpen ? 'inherit' : 'default'}
            >
              <CloudIcon />
            </IconButton>
            </Tooltip>
          }
          {service.multiselect && (
            <Tooltip id={'multiSelectIcon'} title={'select multiple'}>
              <IconButton
                onClick={this.handleMultiselectToggled}
                color={multiselectToggled ? 'inherit' : 'default'}
              >
                <MultiSelectIcon />
              </IconButton>
            </Tooltip>
          )}
          {service.multiselect && (
            <Tooltip id={'clearSelectionIcon'} title={'clear selection'}>
              <IconButton
                onClick={this.handleClearSelectionClicked}
                color={'default'}
              >
                <ClearSelectionIcon />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip id={'layersIcon'} title={'configure layers'}>
            <IconButton
              onClick={this.handleLayerConfigurationClicked}
              color={layerConfigurationOpen ? 'inherit' : 'default'}
            >
              <LayersIcon />
            </IconButton>
          </Tooltip>
        </CardActions>
        <Divider light />
        <CardContent classes={{ root: classes.content }}>
        {service.autocomplete && <AutocompleteContainer />}
        {service.weather &&
          <Collapse key='weatherCollapse' in={weatherOpen}>
            <WeatherContainer />
         </Collapse>
        }
        <Streetview />
        {service.name === 'LeakDetection' && <ItemSummaryContainer id='LeakDetection' />}
        {false && service.name === 'Mopra' && <ItemSummaryContainer id='WellsiteRank' />}
        {service.name === 'LeakDetection' && <LeakDetectionLineChart />}
          {service.name === 'BriggsIce' && <ItemSummaryContainer />}
          {false  === 'SmartIce' && <SmartIceQamutikPointChart />}
          {service.name === 'Infrastructure' && <InfrastructurePieChart />}
          {service.name === 'Infrastructure' && <InfrastructureBufferChart />}
          {service.name === 'LandDeformation' && <LandDeformationLineChart />}
          {false && service.name === 'SmartIce' && <IceBuoyChartContainer />}
          {service.name === 'InlandWaters' && (
            <WaterTemperatureBarChart key='waterTemperatureBarChartContainer' />
          )}
          {service.name === 'InlandWaters' && [
            <WaterSedimentBarChart key='waterSedimentBarChartContainer' />
          ]}
          {service.name === 'InlandWaters' && [
              <WaterLakeTssBarChart key='waterLakeTssBarChartContainer' />
          ]}
          {service.name === 'InlandWaters' && [
              <WaterLakeChlBarChart key='waterLakeTssBarChartContainer' />
          ]}
          {service.name === 'RiverIceHistorical' && [
              <RiverIcePointLineChartContainer key='riverIcePointLineChartContainer' />
          ]}
          {service.name === 'RiverIceHistorical' && [
              <RiverIceLineChartContainer key='riverIceLineChartContainer' />
          ]}
          {service.name === 'Mopra' && <MopraSummaryContainer />}
          {false && service.name === 'Mopra' && [
            <MopraMoodChartContainer key='mopramoodChartContainer' />,
            <Divider key='divider1' light />
          ]}
            {service.name === 'Mopra' && [
              <WellsiteRankContainer key='wellsiteRankContainer' />,
              <MopraWellsitesLineChartContainer key='mopraWellsitesLineChartCOntainer' />,
              <Divider key='divider2' light />
          ]}
              {service.name === 'WellsiteReclamationSimple' && [
                  <WellsiteRankContainerSimple key='wellsiteRankContainerSimple' />,
                <MopraWellsitesLineChartContainer key='mopraWellsitesLineChartCOntainer' />,
                <Divider key='divider2' light />
                ]}

          <Collapse
            key='layerConfigurationOpen'
            in={layerConfigurationOpen}
            unmountOnExit
          >
            <ServiceLayersList
              key='serviceLayersList'
              service={service}
              handleLayerToggled={handleLayerToggled}
              layersRendered={layersRendered}
            />
          </Collapse>
        </CardContent>
      </ServiceDrawerCard>
    )
  }
}

const makeMapStateToProps = () => {
  const getPermission = makeGetPermission()
  const getServiceAuthorized = makeGetServiceAuthorized()

  const mapStateToProps = (state, ownProps) => {
    const { service } = ownProps
    return {
      layerConfigurationOpen: state.service.layerConfigurationOpen,
      locationConfigurationOpen: state.service.locationConfigurationOpen,
      locationSelected: state.serviceCard.locationSelected,
      multiselectToggled: state.object.multiselectToggled,
      uploadToggled: state.object.multiselectToggled,
      weatherOpen: state.service.weatherOpen,
      permission: getPermission(state, service.permissionId),
      services: getServiceAuthorized(state, state.service.services)
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      layerConfigurationToggled: () =>
        dispatch(ServiceActions.layerConfigurationToggled()),
      locationConfigurationToggled: () =>
        dispatch(ServiceActions.locationConfigurationToggled()),
      weatherToggled: () => dispatch(ServiceActions.weatherToggled()),
      multiselectToggled: () => dispatch(ObjectActions.multiselectToggled()),
      uploadToggled: () => dispatch(UploadActions.uploadToggled()),
      objectsSelected: objects =>
        dispatch(ObjectActions.objectsSelected(objects))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  withErrorHandler(withStyles(styles)(ServiceCard))
)



// WEBPACK FOOTER //
// ./src/components/ServiceCard.js